import { useEffect, useState } from 'react';

const useApiData = (apiPath) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  if (!apiPath) {
    return {
      data,
      error: {
        message: 'No api path to get data provided!',
      },
    };
  }

  useEffect(() => {
    let ignore = false;
    fetch(apiPath, { cache: 'no-cache' })
      .then((res) => res.json())
      .then((json) => !ignore && setData(json))
      .catch((er) => setError(er));
    return () => {
      ignore = true;
    };
  }, [apiPath]);

  return { data, error };
};

export default useApiData;
